import { render, staticRenderFns } from "./CampaignDetailsAudience.vue?vue&type=template&id=0518e713&scoped=true"
import script from "./CampaignDetailsAudience.vue?vue&type=script&lang=js"
export * from "./CampaignDetailsAudience.vue?vue&type=script&lang=js"
import style0 from "./CampaignDetailsAudience.vue?vue&type=style&index=0&id=0518e713&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0518e713",
  null
  
)

export default component.exports